import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { isIsoDate, resolveDateOfBirth } from '../../helpers/dateBounds';

/**
 * Clears whenMovedIn when it can no longer be valid against the customer's
 * date of birth (FSL-19280).
 *
 * The date of birth behind the picker's minDate is derived from idNumber on the
 * SA ID journey, and the customer can go back and edit that. If the new DoB
 * lands after an already-captured whenMovedIn, the stale value would sit in a
 * field whose calendar no longer offers it. Clearing it makes the user re-pick
 * from the corrected range rather than leaving a value they cannot reach.
 *
 * Renders nothing - mount it inside the Formik tree, like FormSubmitHelper.
 */
export const MoveInDateSyncHelper = () => {
  const { values, setFieldValue, setFieldTouched } = useFormikContext();

  const whenMovedIn = values?.whenMovedIn;
  const dateOfBirth = resolveDateOfBirth(values);

  useEffect(() => {
    // Both shapes are checked before comparing. Clearing the field is
    // destructive, so a malformed value must never trigger it.
    if (!isIsoDate(whenMovedIn) || !isIsoDate(dateOfBirth)) {
      return;
    }

    // Lexicographic compare is correct for zero-padded YYYY-MM-DD.
    if (whenMovedIn >= dateOfBirth) {
      return;
    }

    setFieldValue('whenMovedIn', '');
    setFieldTouched('whenMovedIn', false);
  }, [whenMovedIn, dateOfBirth, setFieldValue, setFieldTouched]);

  return null;
};
